var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.24 20.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252529;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.9,20.93c-.16-.04-.32-.07-.47-.11C1,20.43,0,19.16,0,17.68,0,12.87,0,8.06,0,3.25,0,1.45,1.47,0,3.27,0c3.07,0,6.13,0,9.2,0,.6,0,1.03.41,1.04.97,0,.58-.43.99-1.04.99-3.01,0-6.02,0-9.03,0-.93,0-1.46.53-1.46,1.45,0,4.7,0,9.4,0,14.1,0,.92.53,1.45,1.46,1.45,3.02,0,6.04,0,9.05,0,.52,0,.93.33,1.01.81.08.51-.19.94-.7,1.12-.02,0-.05.02-.07.04H2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.82,11.45c-.07,0-.15,0-.22,0-2.47,0-4.93,0-7.4,0-.56,0-.99-.38-1.03-.91-.04-.57.4-1.05,1-1.05.99,0,1.99,0,2.98,0,1.48,0,2.96,0,4.43,0,.07,0,.15,0,.27,0-.07-.08-.12-.13-.16-.18-.92-.93-1.85-1.85-2.77-2.77-.29-.29-.4-.63-.28-1.03.21-.69,1.05-.92,1.59-.44.05.05.1.09.15.14,1.49,1.49,2.98,2.98,4.47,4.46.52.52.52,1.06,0,1.58-1.5,1.5-3.01,3-4.51,4.51-.27.27-.58.4-.96.32-.38-.08-.63-.32-.73-.69-.11-.38,0-.71.28-.99.92-.92,1.84-1.84,2.76-2.76.05-.05.12-.09.18-.13-.02-.02-.03-.05-.05-.07Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e893491cb6f9f86eca82dc433aaf525b.svg";
export { ForwardRef as ReactComponent };